export default __webpack_public_path__ + "static/media/les_andelys15.503fc0c0.jpg";